import { CheckCircle, Eraser, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

interface QABulkActionBarProps {
  selectedCount: number;
  onMarkReviewed: () => void;
  onClearIssues: () => void;
  onClearSelection: () => void;
  isLoading?: boolean;
}

export function QABulkActionBar({
  selectedCount,
  onMarkReviewed,
  onClearIssues,
  onClearSelection,
  isLoading = false,
}: QABulkActionBarProps) {
  if (selectedCount === 0) return null;

  return (
    <div
      className={cn(
        "fixed bottom-0 left-0 right-0 z-50",
        "bg-background border-t shadow-lg",
        "px-6 py-3",
        "flex items-center justify-between",
        "animate-in slide-in-from-bottom-4"
      )}
    >
      <span className="font-medium">
        {selectedCount} {selectedCount === 1 ? "post" : "posts"} selected
      </span>

      <div className="flex gap-2">
        <Button
          variant="default"
          onClick={onMarkReviewed}
          disabled={isLoading}
        >
          <CheckCircle className="w-4 h-4 mr-2" />
          Mark Selected as Reviewed
        </Button>
        <Button
          variant="outline"
          onClick={onClearIssues}
          disabled={isLoading}
        >
          <Eraser className="w-4 h-4 mr-2" />
          Clear Issues for Selected
        </Button>
        <Button
          variant="ghost"
          onClick={onClearSelection}
          disabled={isLoading}
        >
          <X className="w-4 h-4 mr-2" />
          Clear
        </Button>
      </div>
    </div>
  );
}
